import { TableCell, TableHead, TableRow, Checkbox } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { SelectedSort } from '@/hooks/useSortableData';
import { ColumnConfig } from './Table';
import { SortableRow } from './SortableRow';

interface TableHeaderProps {
  columns: ColumnConfig[];
  isGhost?: boolean;
  selectedSort?: SelectedSort;
  renderActions?: (rowData: Record<string, any>) => React.ReactNode;
  /** Dónde va la columna de acciones. Por defecto al final. */
  actionsPosition?: 'start' | 'end';
  handleSort?: (key: string) => void;
  selectable?: boolean;
  selectedKeys?: Set<string>;
  data?: any[];
  maxSelectable?: number;
  isAllSelected?: boolean;
  onSelectAll?: (checked: boolean) => void;
  /** Estilos extra en celdas de cabecera (p. ej. `fontSize` en tablas densas). */
  headerCellSx?: SxProps<Theme>;
}

export const TableHeader = ({
  columns,
  renderActions,
  actionsPosition = 'end',
  selectedSort,
  handleSort,
  isGhost,
  selectable,
  selectedKeys,
  data = [],
  maxSelectable,
  isAllSelected = false,
  onSelectAll,
  headerCellSx,
}: TableHeaderProps) => (
  <TableHead>
    <TableRow>
      {selectable && (
        <TableCell
          padding='checkbox'
          sx={[{ width: '48px' }, ...(headerCellSx ? [headerCellSx] : [])]}
        >
          <Checkbox
            indeterminate={
              !isAllSelected && selectedKeys && selectedKeys.size > 0
            }
            checked={isAllSelected}
            onChange={(e) => onSelectAll?.(e.target.checked)}
            disabled={data.length === 0}
          />
        </TableCell>
      )}
      {renderActions && actionsPosition === 'start' && (
        <TableCell sx={{ opacity: 1, width: '56px' }} />
      )}
      {columns.map((column) => (
        <TableCell
          key={column.field}
          sx={[
            {
              cursor: column?.sortable ? 'pointer' : 'default',
            },
            ...(headerCellSx ? [headerCellSx] : []),
          ]}
          onClick={() => column?.sortable && handleSort?.(column?.field)}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'bold',
              color: isGhost
                ? 'var(--secondary-color)'
                : 'var(--primary-color)',
              opacity: isGhost ? 0.5 : 1,
              fontStyle: isGhost ? 'italic' : 'normal',
            }}
          >
            {column.label}
            <SortableRow column={column} selectedSort={selectedSort} />
          </div>
        </TableCell>
      ))}
      {renderActions && actionsPosition === 'end' && (
        <TableCell
          sx={[{ opacity: 1 }, ...(headerCellSx ? [headerCellSx] : [])]}
        />
      )}
    </TableRow>
  </TableHead>
);
